var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChatOffline',{attrs:{"chat-list":_vm.chatList,"username":_vm.username,"is-admin":_vm.isAdminOwn,"is-past":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }